export default "__VITE_ASSET__69ff60f1__"